import { Link } from "react-router-dom";
import { Clock, Layers } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { FORMAT_LABELS, money } from "@/lib/api";

export function CourseCard({ c, to, testid }) {
  return (
    <Link to={to || `/learn/courses/${c.id}`} data-testid={testid || `course-card-${c.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white transition-shadow hover:shadow-md">
      {c.cover_url && (
        <div className="aspect-[16/9] overflow-hidden bg-slate-100">
          <img src={c.cover_url} alt="" loading="lazy" width="800" height="450" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
        </div>
      )}
      <div className="flex flex-1 flex-col p-5">
        <div className="mb-3 flex flex-wrap items-center gap-2">
          <Badge variant="outline" className="capitalize">{c.level}</Badge>
          <Badge className={c.price ? "bg-slate-900" : "bg-emerald-600 hover:bg-emerald-600"}>{money(c.price, c.currency)}</Badge>
          {c.enrolled && <Badge className="bg-[#222d99]">Enrolled</Badge>}
        </div>
        <h3 className="font-display text-lg font-bold leading-snug text-slate-900 group-hover:text-[#222d99]">{c.title}</h3>
        <p className="mt-1 line-clamp-2 text-sm text-slate-600">{c.description}</p>
        <div className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-1 pt-4 text-xs text-slate-500">
          <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {c.duration_hours}h</span>
          <span className="flex items-center gap-1"><Layers className="h-3.5 w-3.5" /> {c.lesson_count} lessons</span>
          <span>{(c.formats || []).map((f) => FORMAT_LABELS[f]).join(" · ")}</span>
        </div>
      </div>
    </Link>
  );
}
